import { styled } from "styled-components";

export const QuantityDropdown = styled.select`
  border: 1px solid #ccc;
  border-radius: 10px;
`;
